<template>
  <div>
    <div class="modal-center modal-small" :class="{'modal-center__open': modal}">
      <form @submit.prevent="salvarModal">
        <div class="modal__inner">
          <div class="modal-center__container">
            <div class="container">
              <slot></slot>
            </div>
          </div>
          <div class="modal-center__footer border-top">
            <button type="button" class="btn btn-dark" @click="closeModal">
              Voltar
            </button>
            <button type="submit" class="btn btn-primary ml-3" v-if="!preview">Transferir</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalCenter',
  props: ['preview'],
  data() {
    return {
      modal: false
    }
  },
  methods: {
    closeModal() {
      document.body.classList.remove("modal-open");
      this.modal = false;
      this.$emit('cancelarCenter');
    },

    openModal() {
      document.body.classList.add("modal-open");
      this.$emit('loadCenter');
      this.modal = true;
    },

    salvarModal() {
      this.$emit('salvarCenter', (fechar) => {
        this.$emit('fecharCenter');
        if (fechar) this.closeModal();
      });
    }
  },

  created() {
    this.$parent.$on('openModalCenter', () => {
      this.openModal();
    });

    this.$parent.$on('closeModalCenter', () => {
      this.closeModal();
    });
  }
}
</script>

<style scoped>
.modal-center {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: left;
  background: rgba(0,0,0,.7);
  transition: opacity .25s ease;
  z-index: 1090;
}

.modal-center__open {
  opacity: 1;
  visibility: visible;
}

.modal__inner {
  transition: top .25s ease;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  overflow: auto;
  background: #fff;
  border-radius: 4px;
  width: 80%;
  height: 80%;
}

.modal-center__container {
  height: 85%;
  padding-top: 16px;
  overflow: auto;
  padding-bottom: 40px;
}

.modal-center__footer {
  height: 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 8px;
}

.modal-small .modal__inner {
  width: 350px;
  height: 420px;
}

@media screen and (max-width: 768px) {
  .modal__inner {
    width: 100%!important;
    max-width: none!important;
    min-width: auto!important;
    border-radius: 0;
    height: 100%!important;
    box-sizing: border-box;
  }

  .modal__inner .modal-center__container {
    height: 90%;
  }

  .modal__inner .modal-center__footer {
    height: 10%;
  }
}
</style>
